import { apiCallGetUsersAlbum } from "../../../api/user-api/api-call-get-user-album";
import getCorePopUpStore from "../../core/core-popup-store";

const getUserAlbum = async (userID: number) => {
  try {
    const { data, status, code } = await apiCallGetUsersAlbum({
      userID
    });
    if (status === "OK") {
      return data;
    }
    getCorePopUpStore().showAlertMessage(code);
    return code;
  } catch (error) {
    return error;
  }
};

export default getUserAlbum;
